import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Messages() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to wants-chat
    navigate('/wants-chat', { replace: true });
  }, [navigate]);

  return null;
}
